import styled from '@emotion/styled'

import { Alert, MasterDetail, Section, Space } from '../../../../../components/core-v2'
import { StrategyType } from '../../../types'
import { StrategyActions, StrategyId, StrategyStepState } from '../state/strategy-slice'
import { Charts } from './charts'
import { StrategyEditor } from './strategy-editor'

export type StrategyStatelessProps = {
  actions: StrategyActions
  onCloseInspection: () => void
  onMoveBack: () => void
  onSaveAndContinue: () => void
  state: StrategyStepState
}

const StyledView = styled.div`
  height: calc(100vh - 184px);
  overflow-y: auto;
`

export function StrategyStepStateless({
  actions,
  onCloseInspection,
  onMoveBack,
  onSaveAndContinue,
  state
}: StrategyStatelessProps) {
  if (state.isReferenceDataFetchError) {
    return (
      <Space mt={4}>
        <Alert title="Data error" type="error">
          There was an error loading the strategies. Please try refreshing the page.
        </Alert>
      </Space>
    )
  }
  const onSetStrategyType = (type: StrategyType) => {
    actions.setType(type)
    if (type === 'delta1') {
      actions.setId(StrategyId.DELTA_1)
    }
    if (type === 'riskmanaged') {
      actions.setId(StrategyId.RISK_MANAGED)
    }
    if (type === 'protection') {
      actions.setId(StrategyId.PROTECTION_CONTINUOUS)
    }
    if (type === 'leverage') {
      actions.setId(StrategyId.LEVERAGE_CONSTANT_PROPORTION)
    }
  }

  return (
    <MasterDetail
      detailBackground="transparent"
      detailChildren={
        <StyledView>
          <Section my={6} type="primary">
            <Charts
              isErrorGeneratingPerformanceChart={state.isErrorGeneratingPerformanceChart}
              isErrorGeneratingProjectionChart={state.isErrorGeneratingProjectionChart}
              isGeneratingPerformanceChart={state.isGeneratingPerformanceChart}
              isGeneratingProjectionChart={state.isGeneratingProjectionChart}
              isMoreDataNeeded={!state.canProceed}
              performanceMetrics={state.performanceMetrics}
              projection={state.projection}
            />
          </Section>
        </StyledView>
      }
      masterBackground="white98"
      masterChildren={
        <StyledView>
          <StrategyEditor
            canMoveNext={state.canProceed}
            state={state}
            onCloseInspection={onCloseInspection}
            onMoveBack={onMoveBack}
            onMoveNext={onSaveAndContinue}
            onSetType={onSetStrategyType}
          />
        </StyledView>
      }
      width="half"
    />
  )
}
